import React from 'react';

import Variant from 'types/shopify/Variant';

import './Variants.sass';

interface Props {
    selectedItem: number;
    variants: Variant[];
    handleVariantSelect(selection: number): void;
}

const Variants: React.StatelessComponent<Props> = (props: Props) => {
    return (
        <div className="variant-select-wrap">
            <label className="variant-select-label" htmlFor="variant-select">Options:</label>
            <div className="variants">
                {props.variants.map((variant, index) => {
                    const isSelected = index === props.selectedItem;
                    return (
                        <div key={variant.id} className={`variant-wrap${isSelected ? ' selected' : ''}`}>
                            <input type="radio" value={variant.id} onChange={() => props.handleVariantSelect(index)} checked={isSelected} />
                            ${Number(variant.price).toFixed(2)} - {variant.title}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Variants;



// WEBPACK FOOTER //
// ./src/components/pages/accessories/detail/Variants.tsx